import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { SessionUserSelectors } from '~src/app/selectors/SessionInfoSelectors';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { updateBreadcrumbs } from '~src/spacesPlatform/actions/UpdateBreadcrumbsAction';
import { selectContentTotalLength } from '~src/spacesPlatform/selectors/ContentSelectors';
import { selectSpaceInfo } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';

import { AppState } from '../../../state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../../utils/ConnectUtils';
import { AllSiteUsersAndIdentitiesSpace,AllSiteUsersAndIdentitiesSpaceDispatchProps,AllSiteUsersAndIdentitiesSpaceOwnProps, AllSiteUsersAndIdentitiesSpaceStateProps } from './AllSiteUsersAndIdentitiesSpace';

const mapStateToProps: MapStateToProps<AllSiteUsersAndIdentitiesSpaceStateProps> = (state: AppState) => ({
  spaceInfo: selectSpaceInfo(state),
  numberOfFetchedUsers: selectContentTotalLength(state),
  isBusyFetchingItems: state.contentExplorer.content.isBusy,

  isSessionMultiSite: SessionUserSelectors.isSessionMultiSite(state),
  isSessionServerAdmin: SessionUserSelectors.isSessionServerAdmin(state),
  canSessionUserManageUsers: SessionUserSelectors.canManageUsers(state),
});

const mapDispatchToProps: MapDispatchToProps<AllSiteUsersAndIdentitiesSpaceDispatchProps> = (dispatch) => bindActionCreators({
    requestSpaceContents,
    updateBreadcrumbs
  }, dispatch);

export const ConnectedAllSiteUsersAndIdentitiesSpace: React.ComponentClass<AllSiteUsersAndIdentitiesSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(AllSiteUsersAndIdentitiesSpace);
